import { axiosInstance } from "./axiosInstance";

export enum NewsletterType {
  DESTAQUE = "DESTAQUE",
  CAMPANHA = "CAMPANHA",
  NOTICIA = "NOTICIA"
}
export type NewsLetterResponse = {
    id: string
    title: string
    content: string
    imageUrl: string | null
    thumbnail: string | null
    type: NewsletterType
    labelLink: string | null
    link: string | null
    createdAt: Date
    updatedAt: Date
};


export type NewsletterCreate = {
    id?: string
    title: string
    content: string
    imageUrl?: string
    thumbnail?: string
    type: NewsletterType
    labelLink?: string
    link?: string
    createdAt?: Date
    updatedAt?: Date
};



export const getNewsletterById = async (id: string): Promise<NewsLetterResponse> => {
  try {
    const response = await axiosInstance.get<NewsLetterResponse>(`/api/newsletter/${id}`);
    return response.data;
  } catch (error) {
        console.error("Erro ao obter Newsletter:", error);
        throw error;
  }
};

export const getAllNewsletter = async (): Promise<NewsLetterResponse[]> => {
  try {
    const response = await axiosInstance.get<NewsLetterResponse[]>(`/api/newsletter`);
    if(response.status !== 200){
      throw new Error('Erro ao buscar newsletters');
    }

    return response.data;
  } catch (error) {
    console.error('Error fetching newsletter:', error);
    throw error;
  }
};


export const createNewsletter = async (
  newsletterData: Partial<NewsletterCreate>
): Promise<void> => {
  try {
   await axiosInstance.post<void>(
      `/api/newsletter`,
      newsletterData
    );
   
  } catch (error) {
    console.error("Erro ao criar newsletter:", error);
    throw error;
  }
};

export const updateNewsletter = async (
  id: string,
  newsletterData: Partial<NewsletterCreate>
): Promise<void> => {
  try {
    const response = await axiosInstance.put<void>(
      `/api/newsletter/${id}`,
      newsletterData
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar newsletter:", error);
    throw error;
  }
};

export const deleteNewsletter = async (id: string): Promise<void> => {
  try {
    await axiosInstance.delete(`/api/newsletter/${id}`);
  } catch (error) {
    console.error("Erro ao deletar newsletter:", error);
    throw error;
  }
};
